export const translations = {
  en: {
    // Navbar
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      contact: "Contact",
    },
    
    // Home Page
    home: {
      // Hero Section
      heroTitle: "Future-Ready Technology for Future-Ready Companies",
      heroDescription: "Delivering powerful IT and AI services designed to scale your business and transform your operations.",
      ctaButton: "BEGIN TODAY WITH US",
      
      // Feature Cards
      feature1Title: "Smarter insights",
      feature1Desc: "Make faster, data-driven decisions powered by real-time AI analysis and prediction.",
      feature2Title: "Integrated AI solutions",
      feature2Desc: "No extra tools or plugins needed. Scalable AI from day one.",
      feature3Title: "End-to-end automation",
      feature3Desc: "Eliminate bottlenecks with intelligent workflows that never leave you guessing.",
      
      // Who We Are
      whoWeAreLabel: "Who We Are?",
      whoWeAreTitle1: "We helping",
      whoWeAreTitle2: "grow businesses",
      whoWeAreTitle3: "and",
      whoWeAreTitle4: "scale with smart, data-driven",
      whoWeAreTitle5: "AI agency",
      
      // Services Heading
      servicesLabel: "Our Main Services",
      servicesTitle1: "Helping you grow",
      servicesTitle2: "with the power of AI",
      servicesViewBtn: "VIEW MORE SERVICES",
      
      // Services Expand
      cloudTitle: "Cloud Services",
      cloudDesc: "Transform your business with scalable cloud infrastructure. We deliver enterprise-grade cloud solutions that enhance performance, reduce costs, and ensure seamless scalability. From migration to optimization, our experts architect cloud environments that drive innovation and accelerate your digital transformation journey.",
      
      biTitle: "BI Analytical Services",
      biDesc: "Unlock the power of your data with advanced Business Intelligence solutions. We transform raw data into actionable insights through interactive dashboards, predictive analytics, and intelligent reporting. Make data-driven decisions faster and stay ahead of market trends with our comprehensive BI expertise.",
      
      qaTitle: "QA Services",
      qaDesc: "Ensure flawless software delivery with our comprehensive Quality Assurance solutions. We employ cutting-edge testing methodologies, automation frameworks, and continuous testing practices to guarantee superior product quality. From functional to performance testing, we safeguard your reputation with zero-defect releases.",
      
      mgTitle: "Managed Services",
      mgDesc: "Focus on your core business while we manage your IT infrastructure. Our proactive managed services provide 24/7 monitoring, maintenance, and support to ensure optimal system performance. Reduce downtime, enhance security, and achieve operational excellence with our dedicated team of experts.",
      
      amsTitle: "AMS Services",
      amsDesc: "Maximize your application investments with our Application Management Services. We provide end-to-end support, maintenance, and enhancement for your critical applications. From incident resolution to performance optimization, our AMS ensures your applications run smoothly, efficiently, and align with evolving business needs.",
      
      // Projects Section
      projectsLabel: "Industries",
      project1Title: "AI-Powered Customer Support Platform",
      project1Desc: "Developed an intelligent chatbot system that reduced response time by 70% and handled 50,000+ customer queries monthly. The NLP-powered solution achieved 95% accuracy in intent recognition, significantly improving customer satisfaction scores.",
      project1Industry: "Data Processing",
      
      project2Title: "Enterprise E-Commerce Transformation",
      project2Desc: "Built a scalable e-commerce platform with AI-driven recommendations that increased conversion rates by 45% and average order value by 32%. The system processes 1M+ transactions monthly with 99.9% uptime, delivering personalized shopping experiences.",
      project2Industry: "Artificial Intelligence",
      
      project3Title: "Smart Manufacturing Quality Control",
      project3Desc: "Implemented an AI-powered computer vision system that automated product inspection, detecting defects with 98% accuracy. The solution reduced inspection time by 80% and saved $2M+ annually in quality control costs for a major manufacturer.",
      project3Industry: "Computer Vision",
      
      project4Title: "Predictive Analytics Dashboard",
      project4Desc: "Created a real-time analytics platform that forecasts business trends with 92% accuracy, processing 10TB+ of data daily. The solution enabled data-driven decision making, resulting in 25% revenue growth and optimized resource allocation for enterprise clients.",
      project4Industry: "Data Science",
      
      readMoreBtn: "READ MORE",
      industryLabel: "Industry:",
      techLabel: "Core Technologies:",
      
      // Industries Section
      industriesLabel: "Industries",
      industriesTitle1: "Expertise that",
      industriesTitle2: "Empowers Industries",
      industriesTitle3: "Worldwide",
      
      industry1Title: "Banking Finance Sector",
      industry1Desc: "Enabling SMEs with innovative technologies that optimize efficiency and meet their banking needs.",
      
      industry2Title: "Insurance",
      industry2Desc: "Scalable solutions that generate customer value and enhance your company's digital journey.",
      
      industry3Title: "Telecom",
      industry3Desc: "Solutions that drive growth and enable businesses to thrive in the rapidly evolving digital landscape.",
      
      industry4Title: "Automotive",
      industry4Desc: "AI-driven automotive solutions tailored to ensure enhanced security, and state-of-the-art automation.",
      
      // Solutions Section
      solutionsLabel: "Solutions",
      solutionsTitle1: "Scalable Solutions that Drive",
      solutionsTitle2: "Meaningful Results",
      
      solution1Name: "AI Solutions",
      solution1Desc: "AI solutions engineered to give your business a competitive edge.",
      
      solution2Name: "Legacy Modernization",
      solution2Desc: "AI-driven Legacy Modernization solutions that ensure seamless transition to modern platforms and drive innovation.",
      
      solution3Name: "Test Automation Solutions",
      solution3Desc: "We deliver high quality automated testing solutions, improving efficiency and ensuring optimal value",
      
      solution4Name: "Regulatory & Compliance Solutions",
      solution4Desc: "Leveraging the latest technologies, we address regulatory changes and ensure industry compliance.",
      
      solution5Name: "Credit Risk Management Solutions",
      solution5Desc: "Empowering financial institutions with Basel-compliant Credit, Market & Operational Risk systems",
      
      // Why Choose Us
      whyLabel: "Why Should Choose Us",
      whyTitle1: "Your success",
      whyTitle2: "is our mission",
      
      whyCard1: "Secure, ethical & scalable AI",
      whyCard2: "Custom-built solutions that fit you",
      whyCard3: "Secure, ethical, and responsible AI",
      whyCard4: "Expert team of AI specialists",
      whyCard5: "Speed without sacrificing quality",
      whyCard6: "Client-centered, business-focused",
      
      // Footer
      footerWhatLabel: "WHAT WE DO?",
      footerWhatTitle: "Services",
      footerWhoLabel: "WHO WE ARE?",
      footerWhoTitle: "About Us",
      footerHowLabel: "HOW WE DELIVER",
      footerHowTitle: "Contact Us",
      footerFacebook: "FACEBOOK",
      footerTwitter: "TWITTER",
      footerLinkedin: "LINKEDIN",
      footerInstagram: "INSTAGRAM",
      footerAddress: "Marina Plaza - Al Marsa Street, Marina Plaza, Level 27-29 & 32, Dubai, United Arab Emirates",
      footerCopyright: "Copyright © 2018 diostec, All rights reserved.",
    },
    
    // About Page
    about: {
      breadcrumb: "Diostec / About us",
      heroTitle: "ABOUT US",
      heroDesc1: "At Diostec, we believe in the transformative power of technology and the boundless potential of individuals. Established in 2018 with a vision to bridge the gap between talent and opportunity, we specialize in IT Services and AI products services that propel both businesses and careers forward.",
      
      stat1Number: "150+",
      stat1Label: "Qualified Employees",
      stat2Number: "20+",
      stat2Label: "Years Of Experience",
      stat3Number: "6+",
      stat3Label: "Services Worldwide",
      stat4Number: "100%",
      stat4Label: "Client Satisfaction",
      
      missionLabel: "Our Mission",
      missionTitle: "Our mission is simple yet powerful: to empower individuals and organizations by leveraging the latest in AI and technology.",
      missionDesc: "We are committed to delivering innovative solutions that not only meet but exceed expectations, fostering growth, efficiency, and success across diverse industries.",
      
      visionLabel: "Our Vision",
      visionTitle: "To be the leading catalyst for digital transformation and talent empowerment globally.",
      visionDesc: "We envision a future where technology and human potential converge seamlessly, creating opportunities for businesses to thrive and individuals to achieve their fullest potential.",
      
      approachLabel: "Our Approach",
      approachTitle: "We combine cutting-edge technology with deep industry expertise",
      approachDesc: "Our approach is rooted in understanding your unique challenges and crafting tailored solutions that drive real results. Whether it's through AI-driven insights, cloud-based innovations, or strategic talent placement, we ensure that every solution is aligned with your business objectives.",
      
      teamLabel: "Our Team",
      teamTitle: "Our team consists of seasoned professionals with expertise across various domains",
      teamDesc: "From AI specialists and cloud architects to experienced recruiters, we bring together a diverse set of skills to serve our clients better.",
      
      // Why Work With Us Section
      whyWorkTitle: "WHY WORK WITH US",
      whyWork1Title: "Long-Term Cooperation &<br />Support",
      whyWork1Desc: "Over 80% of our clients partner with us for 7+ years, supported by a dedicated team with 5+ years of collaboration experience.",
      whyWork2Title: "Accelerated Software<br />Development",
      whyWork2Desc: "We reduce development time by 50% through pre-built solutions, ensuring faster delivery of POCs, prototypes, and final products.",
      whyWork3Title: "Quality Assurance &<br />Compliance",
      whyWork3Desc: "Committed to CMMI and ISO standards, we ensure consistent quality, process optimization, and continuous improvement.",
      whyWork4Title: "Agile & SCRUM Practices",
      whyWork4Desc: "We leverage Agile and SCRUM methodologies to enable a flexible, transparent, and collaborative project management approach.",
      
      // Legacy Section
      legacyTitle: "Our Legacy",
      legacyIntro: "was founded by a team of passionate individuals 7 years ago, fuelled by their vision and determination to create a better future through technology.",
      legacyPara1: "Shortly after its inception, Diostec Software Solutions has positioned itself as one of the most sought-after technology companies over the world through our legendary product 'Forms*Converter' which eases Oracle Forms Migration.",
      legacyPara2: "We started as a product development company and eventually extended our wings to legacy migrations, and now we have transcended into a Technology Company that houses competences for a large spectrum of IT practices.",
      legacyPara3: "Diostec Software Solutions is one of the few companies that has witnessed the IT revolution in the information era and has grown along with it thereby combining experiences and also understanding its intricate nuances.",
      legacyPara4: "7 years in the industry, footprint in over 20 countries and our commendable top-notch collaborations have presented us with an impeccable volume of knowledge and resources that are deployed to best use for today's and future technology demands.",
      
      // Capabilities Section
      capabilitiesTitle: "Our Capabilities",
      capabilitiesSubtitle: "Diostec has spread its wings of capabilities from a simple migration support company to the universe of following IT capabilities to meet the dynamic demands of the clients in agile and swifter routines",
      capability1: "Application Migration<br />and Re-engineering",
      capability2: "Database<br />Migration",
      capability3: "Application<br />Development",
      capability4: "Application Maintenance<br />& Production Support",
      capability5: "Software<br />Testing",
      capability6: "IT<br />Consulting",
      capability7: "System<br />Integration",
      capability8: "Infrastructure<br />Management Services",
      capability9: "Mobile Application<br />Development",
      capability10: "Machine<br />Learning",
      capability11: "Cloud<br />Services",
      
      // Values Section
      valuesTitle: "Our Values",
      value1Title: "Enterprise Digital<br />Transformation",
      value1Desc: "Enabling end to end enterprise digital transformation has been our mantra ever since the day we began our very first enterprise migration",
      value2Title: "Expert<br />Innovation",
      value2Desc: "Infusing innovation in every aspect of solution delivery by nurturing an innovation powerhouse within Diostec software solutions",
      value3Title: "Information<br />Security",
      value3Desc: "State of the art security protocols and ISMS practices ingrained in the very DNA of Diostec software solutions",
      value4Title: "Immense value<br />proposition",
      value4Desc: "Delivering beyond maximum value to the client through intelligent automation and innovation in all aspects of solution delivery",
      value5Title: "Client<br />Centric Engagement",
      value5Desc: "Aligning with our client's best interests in every move and keeping them informed of every action with impeccable transparency all through the engagement",
      value6Title: "Employee<br />Wellness",
      value6Desc: "Empowering our pillars of strength to grow along with the organization and being invested in all aspects of their professional and personal wellness",
      value7Title: "Efficient utilization<br />of resources",
      value7Desc: "Extending our social responsibilities from 'Giving back to the society' to 'Cutting back on the resources' that we use.",
    },
    
    // Services Page
    services: {
      breadcrumb: "DIOSTEC / Services",
      heroTitle: "DIOSTEC SOFTWARE SERVICES",
      heroPara1: "At Diostec Software, we build solutions Driven By Business. With over a decade of experience and more than 50 successful projects, we provide full-cycle custom software development tailored to your unique goals.",
      heroPara2: "We partner with companies to streamline operations, strengthen security, and scale sustainably. From IT consulting to end-to-end development, our services are designed to drive measurable business outcomes—not just deliver code.",
      
      aboutLabel: "ABOUT OUR SERVICES",
      aboutTitle: "ABOUT ",
      aboutTitleHighlight: "US",
      aboutStatNumber: "100+",
      aboutStatText: "Skilled<br />Professionals",
      aboutDesc: "Our software development company is dedicated to providing exceptional service and support, ensuring your projects succeed and your needs are met. Here's why our clients trust us.",
      aboutButton: "About Us",
      
      // Features Section
      feature1Title: "Professional Expertise",
      feature1Desc: "Our team of skilled professionals brings years of experience to deliver exceptional results.",
      
      feature2Title: "Fast Delivery",
      feature2Desc: "We ensure rapid development and deployment without compromising on quality.",
      
      feature3Title: "Quality Assurance",
      feature3Desc: "Rigorous testing and quality checks guarantee reliable and robust solutions.",
      
      feature4Title: "24/7 Support",
      feature4Desc: "Round-the-clock support to ensure your systems run smoothly at all times.",
      
      // What We Offer Section
      offerTitlePart1: "WHAT WE",
      offerTitlePart2: "OFFER",
      
      offer1Title: "Digital Transformation",
      offer1Desc: "Evaluation and modernization of existing systems to improve efficiency, competitiveness, and future-readiness with a detailed transformation plan.",
      
      offer2Title: "IT Consulting",
      offer2Desc: "Expert advice to align IT strategies with business objectives, enhance security, and drive digital transformation.",
      
      offer3Title: "DevOps Consulting Services",
      offer3Desc: "End-to-end DevOps strategies to automate deployments, improve collaboration, and enhance software delivery speed, quality, and resilience.",
      
      offer4Title: "Infrastructure Services",
      offer4Desc: "Comprehensive support for managing and optimizing IT infrastructure, including cloud migration, scalability, and performance improvements.",
      
      offer5Title: "IT Support",
      offer5Desc: "Ongoing technical support and maintenance to ensure system reliability, security, and performance, minimizing downtime and disruptions.",
      
      offer6Title: "Dedicated Development Team",
      offer6Desc: "Scalable, cross-functional engineering teams embedded into your workflow to accelerate delivery, reduce overhead, and adapt to evolving business needs.",
      
      offer7Title: "Web Development",
      offer7Desc: "Full-cycle development focused on custom, user-friendly, and scalable solutions.",
      
      offer8Title: "Mobile App Development",
      offer8Desc: "Tailored mobile app solutions to enhance customer engagement and business operations.",
      
      offer9Title: "UI/UX Design",
      offer9Desc: "Expert design services to create intuitive, visually appealing interfaces for web and mobile applications.",
      
      offer10Title: "Testing & QA",
      offer10Desc: "Comprehensive testing services, including unit, integration, and end-to-end (E2E) testing.",
      
      offer11Title: "MVP Development",
      offer11Desc: "Rapid development of Minimum Viable Products to test ideas, validate concepts, and speed up time-to-market with minimal risk.",
      
      offer12Title: "AI Development",
      offer12Desc: "Custom AI solutions to automate processes, enhance decision-making, and drive innovation tailored to your business needs.",
      
      offer13Title: "ML Development",
      offer13Desc: "Machine learning services to build predictive models, optimize operations, and uncover insights from data for competitive advantage.",
      
      offer14Title: "Product Discovery",
      offer14Desc: "Strategic discovery workshops to define product vision, identify requirements, and align technical solutions with business goals.",
      
      // Application Design & Development Section
      appDesignTitle: "Application Design & Development",
      appDesignSubtitle: "Highly functional and structured services that design and development services that enable considerable cost savings, improved quality, process improvements, and most importantly the benefits of high offshore staffing ratios.",
      
      appDesign1Title: "Solution architecture & design services",
      appDesign1Desc: "Enabling your organization to best understand technology and chart out the most efficient software architecture to accelerate your business potential and drive transformative growth with innovative solutions.",
      
      appDesign2Title: "Prototype development services",
      appDesign2Desc: "Diostec's expertise in developing complex applications enables us to shape your novel ideas to best understand their feasibility in the market, validate concepts, and accelerate time-to-market with minimal investment risk.",
      
      appDesign3Title: "Application enhancement services",
      appDesign3Desc: "Upgrading the capabilities of your existing applications to accommodate the latest technology features to meet your dynamic business requirements effectively, ensuring scalability, performance, and competitive advantage.",
      
      // Maintenance Section
      maintenanceTitle: "Diostec's Approach for Maintenance",
      maintenanceDesc: "Diostec's four-stage approach comprises application maintenance and production support that is supplemented with a unique set of additional processes, which bring measurable cost advantage and operational efficiency to your business operations.",
      
      maintenanceStage1: "Initiation",
      stage1Item1: "Assessment",
      stage1Item2: "Finalize Scope",
      stage1Item3: "Requirements",
      stage1Item4: "Contract",
      stage1Item5: "Environment",
      stage1Item6: "Setup",
      stage1Item7: "NDA",
      stage1Item8: "Prioritization",
      stage1Item9: "Communication",
      stage1Item10: "Strategy",
      
      maintenanceStage2: "Knowledge Acquisition",
      stage2Item1: "Business",
      stage2Item2: "Process",
      stage2Item3: "Technology",
      stage2Item4: "Standards",
      stage2Item5: "Execution Strategy",
      stage2Item6: "History",
      stage2Item7: "Analysis",
      stage2Item8: "Documentation",
      
      maintenanceStage3: "Transition & Pilot",
      stage3Item1: "Clarification",
      stage3Item2: "Pilot Planning",
      stage3Item3: "Pilot Execution",
      stage3Item4: "Tracking Metrics",
      stage3Item5: "Reporting",
      stage3Item6: "Improvement Plan",
      
      maintenanceStage4: "Operational State",
      stage4Item1: "Emergency Data Fixes",
      stage4Item2: "Emergency Code Fixes",
      stage4Item3: "CR Planning & execution",
      stage4Item4: "Tracking Metrics",
      stage4Item5: "SLA Reporting",
      stage4Item6: "Causal Analysis",
      
      // Our Process Section
      processTitle: "OUR PROCESS",
      
      process1Title: "NDA & Introductory Session",
      process1Desc: "Our cooperation begins by signing an NDA and scheduling a quick introductory call to understand your needs and requirements. We then explain how our expertise can help you achieve your goals.",
      
      process2Title: "Creating Full Proposal for Scope Doc",
      process2Desc: "We send a proposal to start working on a Scope Document. This detailed guide outlines the structure and design of a software system to align technical implementation and business needs.",
      
      process3Title: "Working on Scope Doc with Tech Leads",
      process3Desc: "We set up a call with our tech leads, who dive into the project details and create a Scope Doc with you. This process typically involves 3-5 calls, spanning 40-60 hours, and is completed within 1-2 weeks.",
      
      process4Title: "Finalizing the Development Proposal",
      process4Desc: "We finalize the scope of work and submit a detailed proposal for the entire development process. This includes key milestones, deliverables, and timelines to ensure transparency and clear expectations.",
      
      process5Title: "Working with the Development Team",
      process5Desc: "We plan and work in weekly sprints using Scrum methodology. The team holds daily 30-minute stand-up meetings to inform and involve you in updates, releases, and retrospectives. We use GitLab to manage and track tasks.",
      
      contactName: "Diostec Team",
      contactRole: "Business Development Manager",
      contactButton: "Discuss Your Project",
      
      // Business Benefits Section
      benefitsTitle: "Business Benefits",
      
      benefit1: "Significant improvement in application stability",
      benefit2: "Cost reduction due to our variable cost approach",
      benefit3: "Meeting the business requirements on time",
      benefit4: "Knowledge Management",
      benefit5: "Reduced risk of operations",
      benefit6: "Improved maintenance productivity",
      benefit7: "Better predictability",
    },
    
    // Contact Page
    contact: {
      label: "CONTACT US",
      heroTitle: "Get In Touch<br />With Our Experts",
      heroDesc1: "Ready to transform the way you work? Whether you need to streamline operations, enhance workflows, or deliver measurable outcomes, Diostec is here to help.",
      heroDesc2: "Contact us today to see how our tailored AI and IT solutions can drive real results for your business. Let's get started.",
      heroDesc3: "You can find our office location on the map below if you'd like to visit or connect with our team in person.",
      
      firstNameLabel: "First Name*",
      lastNameLabel: "Last Name*",
      emailLabel: "Email*",
      companyLabel: "Company name*",
      messageLabel: "Message*",
      submitButton: "Submit",
      
      successMessage: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
      errorMessage: "Oops! Something went wrong. Please try again later.",
    }
  },
  
  ar: {
    // Navbar
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      contact: "اتصل بنا",
    },
    
    // Home Page
    home: {
      // Hero Section
      heroTitle: "تكنولوجيا متقدمة للشركات الطموحة",
      heroDescription: "نقدم خدمات تقنية المعلومات والذكاء الاصطناعي القوية المصممة لتوسيع نطاق أعمالك وتحويل عملياتك.",
      ctaButton: "ابدأ معنا اليوم",
      
      // Feature Cards
      feature1Title: "رؤى أذكى",
      feature1Desc: "اتخذ قرارات أسرع مبنية على البيانات مدعومة بتحليل وتوقعات الذكاء الاصطناعي في الوقت الفعلي.",
      feature2Title: "حلول الذكاء الاصطناعي المتكاملة",
      feature2Desc: "لا حاجة لأدوات أو إضافات إضافية. ذكاء اصطناعي قابل للتطوير من اليوم الأول.",
      feature3Title: "أتمتة شاملة",
      feature3Desc: "القضاء على الاختناقات من خلال سير عمل ذكي لا يتركك في حيرة من أمرك.",
      
      // Who We Are
      whoWeAreLabel: "من نحن؟",
      whoWeAreTitle1: "نحن نساعد",
      whoWeAreTitle2: "في نمو الأعمال",
      whoWeAreTitle3: "و",
      whoWeAreTitle4: "التوسع من خلال البيانات الذكية",
      whoWeAreTitle5: "وكالة الذكاء الاصطناعي",
      
      // Services Heading
      servicesLabel: "خدماتنا الرئيسية",
      servicesTitle1: "نساعدك على النمو",
      servicesTitle2: "بقوة الذكاء الاصطناعي",
      servicesViewBtn: "عرض المزيد من الخدمات",
      
      // Services Expand
      cloudTitle: "الخدمات السحابية",
      cloudDesc: "حوّل عملك باستخدام بنية تحتية سحابية قابلة للتطوير. نقدم حلول سحابية على مستوى المؤسسات تعزز الأداء وتقلل التكاليف وتضمن قابلية التوسع السلسة. من الترحيل إلى التحسين، يقوم خبراؤنا بتصميم بيئات سحابية تدفع الابتكار وتسرع رحلة التحول الرقمي.",
      
      biTitle: "خدمات تحليل ذكاء الأعمال",
      biDesc: "أطلق العنان لقوة بياناتك من خلال حلول ذكاء الأعمال المتقدمة. نحول البيانات الأولية إلى رؤى قابلة للتنفيذ من خلال لوحات معلومات تفاعلية وتحليلات تنبؤية وتقارير ذكية. اتخذ قرارات مبنية على البيانات بشكل أسرع وابق في صدارة اتجاهات السوق.",
      
      qaTitle: "خدمات ضمان الجودة",
      qaDesc: "ضمان تسليم البرمجيات بلا عيوب من خلال حلول ضمان الجودة الشاملة. نستخدم منهجيات اختبار متطورة وأطر أتمتة وممارسات اختبار مستمرة لضمان جودة المنتج المتفوقة. من الاختبار الوظيفي إلى اختبار الأداء، نحمي سمعتك بإصدارات خالية من العيوب.",
      
      mgTitle: "الخدمات المدارة",
      mgDesc: "ركز على أعمالك الأساسية بينما ندير البنية التحتية لتكنولوجيا المعلومات الخاصة بك. توفر خدماتنا المدارة الاستباقية المراقبة والصيانة والدعم على مدار الساعة طوال أيام الأسبوع لضمان الأداء الأمثل للنظام. قلل وقت التوقف عن العمل، وعزز الأمان، وحقق التميز التشغيلي.",
      
      amsTitle: "خدمات إدارة التطبيقات",
      amsDesc: "حقق أقصى استفادة من استثماراتك في التطبيقات من خلال خدمات إدارة التطبيقات. نقدم الدعم والصيانة والتحسين الشامل لتطبيقاتك الحيوية. من حل الحوادث إلى تحسين الأداء، تضمن خدماتنا تشغيل تطبيقاتك بسلاسة وكفاءة.",
      
      // Projects Section
      projectsLabel: "الصناعات",
      project1Title: "منصة دعم العملاء بالذكاء الاصطناعي",
      project1Desc: "طورنا نظام روبوت محادثة ذكي قلل وقت الاستجابة بنسبة 70٪ وتعامل مع أكثر من 50000 استفسار عميل شهريًا. حقق الحل المدعوم بمعالجة اللغة الطبيعية دقة 95٪ في التعرف على النوايا، مما أدى إلى تحسين درجات رضا العملاء بشكل كبير.",
      project1Industry: "معالجة البيانات",
      
      project2Title: "تحول التجارة الإلكترونية للمؤسسات",
      project2Desc: "بنينا منصة تجارة إلكترونية قابلة للتطوير مع توصيات مدفوعة بالذكاء الاصطناعي زادت معدلات التحويل بنسبة 45٪ ومتوسط قيمة الطلب بنسبة 32٪. يعالج النظام أكثر من مليون معاملة شهريًا بوقت تشغيل 99.9٪.",
      project2Industry: "الذكاء الاصطناعي",
      
      project3Title: "مراقبة الجودة الذكية للتصنيع",
      project3Desc: "نفذنا نظام رؤية حاسوبية يعمل بالذكاء الاصطناعي أتمتة فحص المنتجات، واكتشاف العيوب بدقة 98٪. قلل الحل وقت الفحص بنسبة 80٪ ووفر أكثر من 2 مليون دولار سنويًا في تكاليف مراقبة الجودة.",
      project3Industry: "رؤية الحاسوب",
      
      project4Title: "لوحة التحليلات التنبؤية",
      project4Desc: "أنشأنا منصة تحليلات في الوقت الفعلي تتنبأ باتجاهات الأعمال بدقة 92٪، وتعالج أكثر من 10 تيرابايت من البيانات يوميًا. مكن الحل من اتخاذ قرارات مبنية على البيانات، مما أدى إلى نمو الإيرادات بنسبة 25٪.",
      project4Industry: "علم البيانات",
      
      readMoreBtn: "اقرأ المزيد",
      industryLabel: "الصناعة:",
      techLabel: "التقنيات الأساسية:",
      
      // Industries Section
      industriesLabel: "الصناعات",
      industriesTitle1: "خبرة تمكّن",
      industriesTitle2: "الصناعات",
      industriesTitle3: "في جميع أنحاء العالم",
      
      industry1Title: "قطاع التمويل المصرفي",
      industry1Desc: "تمكين الشركات الصغيرة والمتوسطة بتقنيات مبتكرة تعمل على تحسين الكفاءة وتلبية احتياجاتها المصرفية.",
      
      industry2Title: "التأمين",
      industry2Desc: "حلول قابلة للتطوير تولد قيمة للعملاء وتعزز الرحلة الرقمية لشركتك.",
      
      industry3Title: "الاتصالات",
      industry3Desc: "حلول تدفع النمو وتمكن الشركات من الازدهار في المشهد الرقمي سريع التطور.",
      
      industry4Title: "السيارات",
      industry4Desc: "حلول السيارات المدفوعة بالذكاء الاصطناعي مصممة لضمان الأمان المعزز والأتمتة المتطورة.",
      
      // Solutions Section
      solutionsLabel: "الحلول",
      solutionsTitle1: "حلول قابلة للتطوير تحقق",
      solutionsTitle2: "نتائج ذات مغزى",
      
      solution1Name: "حلول الذكاء الاصطناعي",
      solution1Desc: "حلول الذكاء الاصطناعي المصممة لمنح عملك ميزة تنافسية.",
      
      solution2Name: "تحديث الأنظمة القديمة",
      solution2Desc: "حلول تحديث الأنظمة القديمة المدعومة بالذكاء الاصطناعي التي تضمن الانتقال السلس إلى المنصات الحديثة وتدفع الابتكار.",
      
      solution3Name: "حلول أتمتة الاختبار",
      solution3Desc: "نقدم حلول اختبار آلية عالية الجودة، مما يحسن الكفاءة ويضمن القيمة المثلى",
      
      solution4Name: "حلول التنظيم والامتثال",
      solution4Desc: "الاستفادة من أحدث التقنيات، نتعامل مع التغييرات التنظيمية ونضمن الامتثال للصناعة.",
      
      solution5Name: "حلول إدارة مخاطر الائتمان",
      solution5Desc: "تمكين المؤسسات المالية بأنظمة مخاطر الائتمان والسوق والتشغيل المتوافقة مع بازل",
      
      // Why Choose Us
      whyLabel: "لماذا تختارنا",
      whyTitle1: "نجاحك",
      whyTitle2: "هو مهمتنا",
      
      whyCard1: "ذكاء اصطناعي آمن وأخلاقي وقابل للتطوير",
      whyCard2: "حلول مخصصة تناسبك",
      whyCard3: "ذكاء اصطناعي آمن وأخلاقي ومسؤول",
      whyCard4: "فريق خبراء في الذكاء الاصطناعي",
      whyCard5: "سرعة دون التضحية بالجودة",
      whyCard6: "محور العميل، والتركيز على الأعمال",
      
      // Footer
      footerWhatLabel: "ماذا نفعل؟",
      footerWhatTitle: "الخدمات",
      footerWhoLabel: "من نحن؟",
      footerWhoTitle: "معلومات عنا",
      footerHowLabel: "كيف نقدم",
      footerHowTitle: "اتصل بنا",
      footerFacebook: "فيسبوك",
      footerTwitter: "تويتر",
      footerLinkedin: "لينكد إن",
      footerInstagram: "إنستجرام",
      footerAddress: "Marina Plaza - Al Marsa Street, Marina Plaza, Level 27-29 & 32, Dubai, United Arab Emirates",
      footerCopyright: "حقوق الطبع والنشر © 2018 ديوستك، جميع الحقوق محفوظة.",
    },
    
    // About Page
    about: {
      breadcrumb: "ديوستك / من نحن",
      heroTitle: "من نحن",
      heroDesc1: "في ديوستك، نؤمن بالقوة التحويلية للتكنولوجيا والإمكانات اللامحدودة للأفراد. تأسست في عام 2018 برؤية لسد الفجوة بين المواهب والفرص، نحن متخصصون في خدمات تكنولوجيا المعلومات ومنتجات الذكاء الاصطناعي التي تدفع كلاً من الشركات والوظائف إلى الأمام.",
      
      stat1Number: "150+",
      stat1Label: "موظف مؤهل",
      stat2Number: "20+",
      stat2Label: "سنوات من الخبرة",
      stat3Number: "6+",
      stat3Label: "خدمات عالمية",
      stat4Number: "100%",
      stat4Label: "رضا العملاء",
      
      missionLabel: "مهمتنا",
      missionTitle: "مهمتنا بسيطة وقوية: تمكين الأفراد والمنظمات من خلال الاستفادة من أحدث تقنيات الذكاء الاصطناعي والتكنولوجيا.",
      missionDesc: "نحن ملتزمون بتقديم حلول مبتكرة لا تلبي التوقعات فحسب، بل تتجاوزها، وتعزز النمو والكفاءة والنجاح عبر الصناعات المتنوعة.",
      
      visionLabel: "رؤيتنا",
      visionTitle: "أن نكون المحفز الرائد للتحول الرقمي وتمكين المواهب على مستوى العالم.",
      visionDesc: "نتصور مستقبلًا حيث تتلاقى التكنولوجيا والإمكانات البشرية بسلاسة، مما يخلق فرصًا للشركات للازدهار والأفراد لتحقيق إمكاناتهم الكاملة.",
      
      approachLabel: "نهجنا",
      approachTitle: "نحن نجمع بين التكنولوجيا المتطورة والخبرة الصناعية العميقة",
      approachDesc: "يتجذر نهجنا في فهم تحدياتك الفريدة وصياغة حلول مخصصة تحقق نتائج حقيقية. سواء كان ذلك من خلال رؤى مدفوعة بالذكاء الاصطناعي، أو ابتكارات قائمة على السحابة، أو توظيف المواهب الاستراتيجية، نضمن أن كل حل يتماشى مع أهداف عملك.",
      
      teamLabel: "فريقنا",
      teamTitle: "يتكون فريقنا من محترفين متمرسين ذوي خبرة في مختلف المجالات",
      teamDesc: "من متخصصي الذكاء الاصطناعي ومهندسي السحابة إلى المجندين ذوي الخبرة، نجمع مجموعة متنوعة من المهارات لخدمة عملائنا بشكل أفضل.",
      
      // Why Work With Us Section
      whyWorkTitle: "لماذا العمل معنا",
      whyWork1Title: "التعاون والدعم<br />طويل الأجل",
      whyWork1Desc: "أكثر من 80٪ من عملائنا يتعاونون معنا لأكثر من 7 سنوات، مدعومين بفريق مخصص يتمتع بخبرة تعاون تزيد عن 5 سنوات.",
      whyWork2Title: "تطوير برمجيات<br />متسارع",
      whyWork2Desc: "نقلل وقت التطوير بنسبة 50٪ من خلال الحلول الجاهزة، مما يضمن تسليمًا أسرع للنماذج الأولية والمنتجات النهائية.",
      whyWork3Title: "ضمان الجودة<br />والامتثال",
      whyWork3Desc: "ملتزمون بمعايير CMMI وISO، نضمن جودة متسقة وتحسين العمليات والتحسين المستمر.",
      whyWork4Title: "ممارسات Agile وSCRUM",
      whyWork4Desc: "نستفيد من منهجيات Agile وSCRUM لتمكين نهج إدارة مشاريع مرن وشفاف وتعاوني.",
      
      // Legacy Section
      legacyTitle: "إرثنا",
      legacyIntro: "تأسست من قبل فريق من الأفراد المتحمسين قبل 7 سنوات، مدفوعين برؤيتهم وتصميمهم على خلق مستقبل أفضل من خلال التكنولوجيا.",
      legacyPara1: "بعد فترة وجيزة من تأسيسها، وضعت Diostec Software Solutions نفسها كواحدة من أكثر شركات التكنولوجيا المطلوبة في العالم من خلال منتجنا الأسطوري 'Forms*Converter' الذي يسهل ترحيل Oracle Forms.",
      legacyPara2: "بدأنا كشركة لتطوير المنتجات وتوسعنا تدريجيًا إلى عمليات الترحيل القديمة، والآن تحولنا إلى شركة تكنولوجيا تضم كفاءات لمجموعة واسعة من ممارسات تكنولوجيا المعلومات.",
      legacyPara3: "Diostec Software Solutions هي واحدة من الشركات القليلة التي شهدت ثورة تكنولوجيا المعلومات في عصر المعلومات ونمت معها، وبالتالي جمعت الخبرات وفهمت أيضًا تفاصيلها المعقدة.",
      legacyPara4: "7 سنوات في الصناعة، بصمة في أكثر من 20 دولة وتعاوناتنا الممتازة من الدرجة الأولى قدمت لنا حجمًا لا تشوبه شائبة من المعرفة والموارد التي يتم نشرها لأفضل استخدام لمتطلبات التكنولوجيا الحالية والمستقبلية.",
      
      // Capabilities Section
      capabilitiesTitle: "قدراتنا",
      capabilitiesSubtitle: "نشرت Diostec أجنحة قدراتها من شركة دعم ترحيل بسيطة إلى عالم قدرات تكنولوجيا المعلومات التالية لتلبية المتطلبات الديناميكية للعملاء في إجراءات رشيقة وأسرع",
      capability1: "ترحيل التطبيقات<br />وإعادة الهندسة",
      capability2: "ترحيل<br />قواعد البيانات",
      capability3: "تطوير<br />التطبيقات",
      capability4: "صيانة التطبيقات<br />ودعم الإنتاج",
      capability5: "اختبار<br />البرمجيات",
      capability6: "استشارات<br />تكنولوجيا المعلومات",
      capability7: "تكامل<br />الأنظمة",
      capability8: "خدمات إدارة<br />البنية التحتية",
      capability9: "تطوير تطبيقات<br />الهاتف المحمول",
      capability10: "التعلم<br />الآلي",
      capability11: "الخدمات<br />السحابية",
      
      // Values Section
      valuesTitle: "قيمنا",
      value1Title: "التحول الرقمي<br />للمؤسسات",
      value1Desc: "تمكين التحول الرقمي الشامل للمؤسسات كان شعارنا منذ اليوم الذي بدأنا فيه أول عملية ترحيل للمؤسسات",
      value2Title: "الابتكار<br />الخبير",
      value2Desc: "غرس الابتكار في كل جانب من جوانب تقديم الحلول من خلال رعاية قوة ابتكار داخل Diostec software solutions",
      value3Title: "أمن<br />المعلومات",
      value3Desc: "بروتوكولات أمنية حديثة وممارسات ISMS متأصلة في الحمض النووي لـ Diostec software solutions",
      value4Title: "عرض قيمة<br />هائل",
      value4Desc: "تقديم قيمة تتجاوز الحد الأقصى للعميل من خلال الأتمتة الذكية والابتكار في جميع جوانب تقديم الحلول",
      value5Title: "المشاركة التي تركز<br />على العميل",
      value5Desc: "التوافق مع مصالح عملائنا في كل خطوة وإبقائهم على اطلاع بكل إجراء بشفافية لا تشوبها شائبة طوال فترة المشاركة",
      value6Title: "رفاهية<br />الموظفين",
      value6Desc: "تمكين أعمدة قوتنا للنمو مع المنظمة والاستثمار في جميع جوانب عافيتهم المهنية والشخصية",
      value7Title: "الاستخدام الفعال<br />للموارد",
      value7Desc: "توسيع مسؤولياتنا الاجتماعية من 'رد الجميل للمجتمع' إلى 'خفض الموارد' التي نستخدمها.",
    },
    
    // Services Page
    services: {
      breadcrumb: "ديوستك / خدماتنا",
      heroTitle: "خدمات برمجيات ديوستك",
      heroPara1: "في ديوستك سوفت وير، نبني حلولاً مدفوعة بالأعمال. مع أكثر من عقد من الخبرة وأكثر من 50 مشروعًا ناجحًا، نقدم تطوير برمجيات مخصص بدورة كاملة مصمم خصيصًا لأهدافك الفريدة.",
      heroPara2: "نتشارك مع الشركات لتبسيط العمليات وتعزيز الأمان والتوسع بشكل مستدام. من استشارات تكنولوجيا المعلومات إلى التطوير الشامل، تم تصميم خدماتنا لتحقيق نتائج أعمال قابلة للقياس - وليس فقط تقديم كود.",
      
      aboutLabel: "حول خدماتنا",
      aboutTitle: "من ",
      aboutTitleHighlight: "نحن",
      aboutStatNumber: "+100",
      aboutStatText: "محترفون<br />ماهرون",
      aboutDesc: "شركة تطوير البرمجيات لدينا مكرسة لتقديم خدمة ودعم استثنائيين، مما يضمن نجاح مشاريعك وتلبية احتياجاتك. إليك لماذا يثق بنا عملاؤنا.",
      aboutButton: "من نحن",
      
      // Features Section
      feature1Title: "خبرة محترفة",
      feature1Desc: "يتمتع فريقنا من المحترفين المهرة بسنوات من الخبرة لتقديم نتائج استثنائية.",
      
      feature2Title: "تسليم سريع",
      feature2Desc: "نضمن التطوير والنشر السريع دون المساس بالجودة.",
      
      feature3Title: "ضمان الجودة",
      feature3Desc: "اختبارات وفحوصات جودة صارمة تضمن حلولاً موثوقة وقوية.",
      
      feature4Title: "دعم 24/7",
      feature4Desc: "دعم على مدار الساعة لضمان عمل أنظمتك بسلاسة في جميع الأوقات.",
      
      // What We Offer Section
      offerTitlePart1: "ماذا",
      offerTitlePart2: "نقدم",
      
      offer1Title: "التحول الرقمي",
      offer1Desc: "تقييم وتحديث الأنظمة الحالية لتحسين الكفاءة والتنافسية والاستعداد للمستقبل مع خطة تحول تفصيلية.",
      
      offer2Title: "استشارات تكنولوجيا المعلومات",
      offer2Desc: "مشورة متخصصة لمواءمة استراتيجيات تكنولوجيا المعلومات مع أهداف العمل وتعزيز الأمان ودفع التحول الرقمي.",
      
      offer3Title: "خدمات استشارات DevOps",
      offer3Desc: "استراتيجيات DevOps شاملة لأتمتة النشر وتحسين التعاون وتعزيز سرعة وجودة ومرونة تسليم البرمجيات.",
      
      offer4Title: "خدمات البنية التحتية",
      offer4Desc: "دعم شامل لإدارة وتحسين البنية التحتية لتكنولوجيا المعلومات، بما في ذلك الترحيل السحابي وقابلية التوسع وتحسينات الأداء.",
      
      offer5Title: "دعم تكنولوجيا المعلومات",
      offer5Desc: "دعم فني مستمر وصيانة لضمان موثوقية النظام وأمانه وأدائه، مع تقليل وقت التوقف والاضطرابات.",
      
      offer6Title: "فريق تطوير مخصص",
      offer6Desc: "فرق هندسية قابلة للتوسع ومتعددة الوإلائف مدمجة في سير عملك لتسريع التسليم وتقليل التكاليف والتكيف مع احتياجات العمل المتطورة.",
      
      offer7Title: "تطوير الويب",
      offer7Desc: "تطوير شامل مركز على حلول مخصصة وسهلة الاستخدام وقابلة للتوسع.",
      
      offer8Title: "تطوير تطبيقات الجوال",
      offer8Desc: "حلول تطبيقات الجوال المخصصة لتعزيز مشاركة العملاء وعمليات الأعمال.",
      
      offer9Title: "تصميم UI/UX",
      offer9Desc: "خدمات تصميم متخصصة لإنشاء واجهات بديهية وجذابة بصريًا لتطبيقات الويب والجوال.",
      
      offer10Title: "الاختبار وضمان الجودة",
      offer10Desc: "خدمات اختبار شاملة، بما في ذلك اختبار الوحدة والتكامل والشامل (E2E).",
      
      offer11Title: "تطوير MVP",
      offer11Desc: "تطوير سريع للمنتجات الأساسية لاختبار الأفكار والتحقق من المفاهيم وتسريع الوصول إلى السوق بأقل المخاطر.",
      
      offer12Title: "تطوير الذكاء الاصطناعي",
      offer12Desc: "حلول ذكاء اصطناعي مخصصة لأتمتة العمليات وتحسين اتخاذ القرارات ودفع الابتكار بما يتناسب مع احتياجات عملك.",
      
      offer13Title: "تطوير تعلم الآلة",
      offer13Desc: "خدمات تعلم الآلة لبناء نماذج تنبؤية وتحسين العمليات واكتشاف رؤى من البيانات للحصول على ميزة تنافسية.",
      
      offer14Title: "اكتشاف المنتج",
      offer14Desc: "ورش عمل استراتيجية لتحديد رؤية المنتج وتحديد المتطلبات ومواءمة الحلول التقنية مع أهداف العمل.",
      
      // Application Design & Development Section
      appDesignTitle: "تصميم وتطوير التطبيقات",
      appDesignSubtitle: "خدمات عالية الوإلائف ومنظمة للتصميم والتطوير تمكن من تحقيق وفورات كبيرة في التكاليف وتحسين الجودة وتحسين العمليات، والأهم من ذلك فوائد نسب التوإلاف الخارجي العالية.",
      
      appDesign1Title: "خدمات بنية وتصميم الحلول",
      appDesign1Desc: "تمكين مؤسستك من فهم التكنولوجيا بشكل أفضل ورسم أكثر بنية برمجية كفاءة لتسريع إمكانات عملك ودفع النمو التحولي مع حلول مبتكرة.",
      
      appDesign2Title: "خدمات تطوير النموذج الأولي",
      appDesign2Desc: "خبرة ديوستك في تطوير التطبيقات المعقدة تمكننا من صياغة أفكارك الجديدة لفهم جدواها في السوق بشكل أفضل، والتحقق من المفاهيم، وتسريع الوصول إلى السوق بأقل مخاطر استثمارية.",
      
      appDesign3Title: "خدمات تحسين التطبيقات",
      appDesign3Desc: "ترقية قدرات تطبيقاتك الحالية لاستيعاب أحدث ميزات التكنولوجيا لتلبية متطلبات عملك الديناميكية بفعالية، مما يضمن قابلية التوسع والأداء والميزة التنافسية.",
      
      // Maintenance Section
      maintenanceTitle: "نهج ديوستك للصيانة",
      maintenanceDesc: "يتضمن نهج ديوستك المكون من أربع مراحل صيانة التطبيقات ودعم الإنتاج التي يتم استكمالها بمجموعة فريدة من العمليات الإضافية، والتي تجلب ميزة تكلفة قابلة للقياس وكفاءة تشغيلية لعملياتك التجارية.",
      
      maintenanceStage1: "البداية",
      stage1Item1: "التقييم",
      stage1Item2: "تحديد النطاق",
      stage1Item3: "المتطلبات",
      stage1Item4: "العقد",
      stage1Item5: "البيئة",
      stage1Item6: "الإعداد",
      stage1Item7: "اتفاقية عدم الإفصاح",
      stage1Item8: "تحديد الأولويات",
      stage1Item9: "التواصل",
      stage1Item10: "الاستراتيجية",
      
      maintenanceStage2: "اكتساب المعرفة",
      stage2Item1: "الأعمال",
      stage2Item2: "العملية",
      stage2Item3: "التكنولوجيا",
      stage2Item4: "المعايير",
      stage2Item5: "استراتيجية التنفيذ",
      stage2Item6: "التاريخ",
      stage2Item7: "التحليل",
      stage2Item8: "التوثيق",
      
      maintenanceStage3: "الانتقال والتجربة",
      stage3Item1: "التوضيح",
      stage3Item2: "تخطيط التجربة",
      stage3Item3: "تنفيذ التجربة",
      stage3Item4: "تتبع المقاييس",
      stage3Item5: "التقارير",
      stage3Item6: "خطة التحسين",
      
      maintenanceStage4: "الحالة التشغيلية",
      stage4Item1: "إصلاحات البيانات الطارئة",
      stage4Item2: "إصلاحات الكود الطارئة",
      stage4Item3: "تخطيط وتنفيذ CR",
      stage4Item4: "تتبع المقاييس",
      stage4Item5: "تقارير SLA",
      stage4Item6: "التحليل السببي",
      
      // Our Process Section
      processTitle: "عمليتنا",
      
      process1Title: "اتفاقية عدم الإفصاح وجلسة تعريفية",
      process1Desc: "يبدأ تعاوننا بتوقيع اتفاقية عدم إفصاح وجدولة مكالمة تعريفية سريعة لفهم احتياجاتك ومتطلباتك. ثم نشرح كيف يمكن لخبرتنا مساعدتك في تحقيق أهدافك.",
      
      process2Title: "إنشاء مقترح كامل لوثيقة النطاق",
      process2Desc: "نرسل مقترحًا لبدء العمل على وثيقة النطاق. يحدد هذا الدليل التفصيلي بنية وتصميم نظام البرمجيات لمواءمة التنفيذ التقني واحتياجات العمل.",
      
      process3Title: "العمل على وثيقة النطاق مع قادة التقنية",
      process3Desc: "نقوم بإعداد مكالمة مع قادة التقنية لدينا، الذين يتعمقون في تفاصيل المشروع وينشئون وثيقة النطاق معك. تتضمن هذه العملية عادة 3-5 مكالمات، تمتد على 40-60 ساعة، وتكتمل في غضون 1-2 أسابيع.",
      
      process4Title: "إنهاء مقترح التطوير",
      process4Desc: "نقوم بوضع نطاق العمل بشكل نهائي وتقديم مقترح تفصيلي لعملية التطوير بأكملها. يتضمن هذا المعالم الرئيسية والتسليمات والجداول الزمنية لضمان الشفافية والتوقعات الواضحة.",
      
      process5Title: "العمل مع فريق التطوير",
      process5Desc: "نخطط ونعمل في سبرنتات أسبوعية باستخدام منهجية Scrum. يعقد الفريق اجتماعات يومية مدتها 30 دقيقة لإعلامك وإشراكك في التحديثات والإصدارات والمراجعات. نستخدم GitLab لإدارة وتتبع المهام.",
      
      contactName: "فريق ديوستك",
      contactRole: "مدير تطوير الأعمال",
      contactButton: "ناقش مشروعك",
      
      // Business Benefits Section
      benefitsTitle: "فوائد الأعمال",
      
      benefit1: "تحسين كبير في استقرار التطبيق",
      benefit2: "تقليل التكلفة بفضل نهج التكلفة المتغيرة لدينا",
      benefit3: "تلبية متطلبات العمل في الوقت المحدد",
      benefit4: "إدارة المعرفة",
      benefit5: "تقليل مخاطر العمليات",
      benefit6: "تحسين إنتاجية الصيانة",
      benefit7: "إمكانية التنبؤ بشكل أفضل",
    },
    
    // Contact Page
    contact: {
      label: "اتصل بنا",
      heroTitle: "تواصل مع<br />خبرائنا",
      heroDesc1: "هل أنت مستعد لتحويل طريقة عملك؟ سواء كنت بحاجة إلى تبسيط العمليات، أو تحسين سير العمل، أو تحقيق نتائج قابلة للقياس، فإن ديوستك هنا للمساعدة.",
      heroDesc2: "اتصل بنا اليوم لترى كيف يمكن لحلول الذكاء الاصطناعي وتكنولوجيا المعلومات المخصصة لدينا أن تحقق نتائج حقيقية لعملك. لنبدأ.",
      heroDesc3: "يمكنك العثور على موقع مكتبنا على الخريطة أدناه إذا كنت ترغب في زيارتنا أو التواصل مع فريقنا شخصيًا.",
      
      firstNameLabel: "الاسم الأول*",
      lastNameLabel: "الاسم الأخير*",
      emailLabel: "البريد الإلكتروني*",
      companyLabel: "اسم الشركة*",
      messageLabel: "الرسالة*",
      submitButton: "إرسال",
      
      successMessage: "شكراً لك! تم إرسال رسالتك بنجاح. سنتواصل معك قريبًا.",
      errorMessage: "عذراً! حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.",
    }
  }
};
